import { render, staticRenderFns } from "./MdPagination.vue?vue&type=template&id=9339c400&"
import script from "./MdPagination.vue?vue&type=script&lang=js&"
export * from "./MdPagination.vue?vue&type=script&lang=js&"
import style0 from "./MdPagination.vue?vue&type=style&index=0&id=9339c400&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports